<template>
  <div>
    <!-- {{fuelData}} -->
    <!-- {{fuelStore.data[location]}} -->
    <table style="width:400px">
      <tr>
        <!-- Month,Total Litres,Total Dollars,Transactions,P@P Litres,P@P Dollars,P@P Count,Store Litres,Store Dollars,Store Count  -->
        <th>Month</th>
        <th>Total Litres</th>
        <th>Total Dollars</th>
        <th>Transactions</th>
        <th>P@P Litres</th>
        <th>P@P Dollars</th>
        <th>P@P Count</th>
        <th>In Store Litres</th>
        <th>In Store Dollars</th>
        <th>In Store Count</th>
      </tr>
      
      <tr v-if="!fuelStore.data[location].isLoading">
        <td style="text-align:right">{{D(fuelData.ts_from, 'MMM-YYYY')}}</td>
        <td style="text-align:right">{{F(fuelData.litres)}}</td>
        <td style="text-align:right">{{F(fuelData.dollars)}}</td>
        <td style="text-align:right">{{F(fuelData.count, '0,0')}}</td>
        <td style="text-align:right">{{F(fuelData.pap_litres)}}</td>
        <td style="text-align:right">{{F(fuelData.pap_dollars)}}</td>
        <td style="text-align:right">{{F(fuelData.pap_count, '0,0')}}</td>
        <td style="text-align:right">{{F(fuelData.instore_litres)}}</td>
        <td style="text-align:right">{{F(fuelData.instore_dollars)}}</td>
        <td style="text-align:right">{{F(fuelData.instore_count, '0,0')}}</td>
      </tr>
    </table>
  </div>


</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'
export default {
  
  inject: ['payAtPumpPage'],
  props: ['location'],
  mixins : [formatDataMixin],
  computed:{
    fuelStore(){
      return this.payAtPumpPage.$refs.fuelStore
    },
    fuelData(){
      return this.fuelStore.data && this.fuelStore.data[this.location] ? this.fuelStore.data[this.location].fuel : undefined;
    },
    isLoading(){
      return this.fuelStore[this.location].isLoading;
    }
  }
  

}
</script>

<style lang="scss" scoped>

</style>